export const ORGANIZATION_SWITCHER_COPY = {
	PLACEHOLDER: 'Select Organization'
};
